<template>
  <div class="quantity">
    <a class="quantity-btn-minus" @click="reduceCount">–</a>
    <input v-model="childCounterValue" class="quantity-text" type="text" readonly />
    <a class="quantity-btn-plus" @click="addCount">＋</a>
  </div>
</template>

<script setup>
const childCounterValue = defineModel();

const props = defineProps({
  reduceCount: {
    type: Function,
    required: true,
  },
  addCount: {
    type: Function,
    required: true,
  },
});
</script>
